import { Wrapper } from "./chip.styles";
import { ChipProps } from "./chip.types";

export const Chip = ({ backgroundColor, children }: ChipProps) => {
	return <Wrapper backgroundColor={backgroundColor}>{children}</Wrapper>;
};
